import { normalizeForSearch } from '@griply/utils';
import {
  NewEntityTypes,
  Suggestion,
  SuggestionTriggers,
} from 'shared/types/nlp';

const createCandidates: Record<SuggestionTriggers, NewEntityTypes[]> = {
  [SuggestionTriggers.LinkedItem]: [
    NewEntityTypes.Goal,
    NewEntityTypes.Project,
  ],
  [SuggestionTriggers.Tag]: [NewEntityTypes.Tag],
  [SuggestionTriggers.Person]: [NewEntityTypes.Person],
};

export type GetCreateSuggestionsOptions = {
  trigger: SuggestionTriggers;
  searchTerm: string;
  existingNames: string[];
  createGoalAllowed: boolean;
  createProjectAllowed: boolean;
};

export const getCreateSuggestions = ({
  trigger,
  searchTerm,
  existingNames,
  createGoalAllowed,
  createProjectAllowed,
}: GetCreateSuggestionsOptions): Suggestion[] => {
  const name = searchTerm.trim();
  if (!name) {
    return [];
  }

  const normalizedName = normalizeForSearch(name);
  const exactMatch = existingNames.some(
    (existingName) => normalizeForSearch(existingName) === normalizedName,
  );
  if (exactMatch) {
    return [];
  }

  const premiumBlocked: Partial<Record<NewEntityTypes, boolean>> = {
    [NewEntityTypes.Goal]: !createGoalAllowed,
    [NewEntityTypes.Project]: !createProjectAllowed,
  };

  return createCandidates[trigger].map((entityType) => ({
    id: null,
    name,
    type: trigger,
    create: { entityType, isPremium: !!premiumBlocked[entityType] },
  }));
};
